export const PROJECT_CREATED_BY_DEFAULT_NAME = 'general';
